import api from '../../api/vo2api'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

let server = new class {
    constructor() {

        this.state = {
            serverVersion: null,
        };

        this.getters = {
            serverVersion:(state) => state.serverVersion,
        };

        this.mutations = {

            setServerVersion (state, value) {
                state.serverVersion = value
            },
        };

        this.actions = {

            ping({ commit }) {

                commit('setServerVersion', null)

                return api.ping().then( res => {

                    let value = res.version;
                    let model = res;

                    commit('setServerVersion', value)

                    return model
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                    return null
                }).then(value => {
                    return value
                });
            },
        }
    }

}

const state = {
    ...server.state,
};
const getters = {
    ...server.getters,
};
const actions = {
    ...server.actions,
};
const mutations = {
    ...server.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};